'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterPostType = function TwitterPostType(_ref) {
  var post = _ref.asset;

  var tweetMedia = _lodash2.default.get(post, 'entities.media') || [];
  var mainTweetMedia = _lodash2.default.head(tweetMedia);
  var mediaUrl = _lodash2.default.get(mainTweetMedia, 'expanded_url');

  var postType = 'post';

  if (_lodash2.default.includes(mediaUrl, 'video')) {
    postType = 'video';
  }
  if (_lodash2.default.includes(mediaUrl, 'photo')) {
    postType = 'photo';
  }

  var types = {
    video: _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'blue' }),
    photo: _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'blue' }),
    post: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' }),
    pagepost: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' })
  };

  return types[postType] || null;
};

exports.default = TwitterPostType;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/twitter-post-type/index.js
 ** module id = 2630
 ** module chunks = 0
 **/